import React from 'react';
import Select from './Select';
import { useOptions } from '../../hooks/useOptions';

/**
 * Dynamic Select Component
 * Renders a select dropdown with options fetched from configuration
 * 
 * @param {string} optionType - Type of options (e.g., 'articleStatus', 'contactPriority')
 * @param {any} value - Selected value
 * @param {function} onChange - Change handler
 * @param {string} label - Label for the select
 * @param {string} placeholder - Placeholder text
 * @param {boolean} includeAll - Include "All" option at the beginning
 * @param {string} allLabel - Label for "All" option
 * @param {any} allValue - Value for "All" option
 * @param {boolean} required - Is field required
 * @param {string} className - Additional CSS classes
 */
const DynamicSelect = ({
  optionType,
  value,
  onChange,
  label,
  placeholder,
  includeAll = false,
  allLabel = 'All',
  allValue = '',
  required = false,
  className = '',
  error,
  ...props
}) => {
  const { options, loading } = useOptions(optionType);

  // Prepare options for Select component
  let selectOptions = options.map(opt => ({
    value: opt.value,
    label: opt.label
  }));

  // Add "All" option if requested
  if (includeAll) {
    selectOptions = [
      { value: allValue, label: allLabel },
      ...selectOptions
    ];
  }

  if (loading) {
    return (
      <Select
        label={label}
        value={value}
        onChange={onChange}
        options={[{ value: '', label: 'Loading...' }]}
        disabled
        className={className}
        error={error}
        {...props}
      />
    );
  }

  return (
    <Select
      label={label}
      value={value}
      onChange={onChange}
      options={selectOptions}
      placeholder={placeholder}
      required={required}
      className={className}
      error={error}
      {...props}
    />
  );
};

export default DynamicSelect;
